import useViewTransitionNavigate from "Hooks/useViewTransitionNavigate";
import { useEffect } from "react";
import { HiOutlineArrowPath, HiOutlineShieldCheck } from "react-icons/hi2";
import { useDispatch } from "react-redux";
import { logout } from "store/reducers/authReducer";

export default function Logout() {
  const dispatch = useDispatch();
  const navigate = useViewTransitionNavigate();

  useEffect(() => {
    const time = setTimeout(() => {
      dispatch(logout());
      navigate("/");
    }, 2300);

    return () => {
      clearTimeout(time);
    };
  }, [dispatch, navigate]);

  return (
    <section className="mx-auto flex min-h-[70vh] w-full max-w-3xl items-center justify-center px-2 py-4">
      <div className="portal-page-card w-full max-w-lg rounded-[2rem] p-5 text-center md:p-7">
        <div className="portal-panel-soft relative mx-auto flex h-40 w-40 items-center justify-center rounded-full">
          <div className="absolute inset-0 rounded-full border border-orange-300/25 animate-pulse" />
          <div className="absolute inset-3 rounded-full border border-orange-400/30" />
          <div className="absolute inset-6 rounded-full border-b-2 border-t-2 border-orange-500/70 animate-spin" />

          <div className="portal-accent-bg relative z-10 flex h-20 w-20 items-center justify-center rounded-[1.8rem] text-white shadow-lg shadow-orange-500/30">
            <HiOutlineShieldCheck className="text-4xl" />
          </div>

          <div className="absolute -bottom-1 -right-1 z-20 flex h-11 w-11 items-center justify-center rounded-full border border-white/15 bg-white/80 text-orange-600 shadow-lg dark:bg-slate-900/80">
            <HiOutlineArrowPath className="animate-spin text-xl" />
          </div>
        </div>

        <h1 className="mt-6 text-2xl font-black" style={{ color: "var(--layout-text)" }}>
          جارٍ تسجيل الخروج
        </h1>
        <p className="mt-2 text-sm leading-6" style={{ color: "var(--layout-text-muted)" }}>
          يتم إنهاء الجلسة وإعادتك إلى الصفحة الرئيسية.
        </p>
      </div>
    </section>
  );
}
